/* eslint-disable */
import { createStore } from 'vuex'

export const store = createStore( {
    
    state()
    {
        return {
            dbConnected:         false,
            uuid:                null,
            online:              false,
            authorized:          false,
            localSessionId:      false,
            remoteSessionId:     false,
            idUser:              false,
            username:            false,
            serial:              false,
            localUrl:            false,
            remoteUrl:           false,
            encryptedPrivateKey: false,
            publicKey:           false,
            proxyKey:            false,
            lastTick:            null,
            storeInitialized:    false,
            localConnected:      false,
            localAuthorized:     false,
            remoteConnected:     false,
            remoteAuthorized:    false
        }
    },
    
    mutations: {
        
        setDatabase( state, value )
        {
            this.database = value
            state.dbConnected = true
            this.commit( 'initStates' )
        },
        
        setEventManager( state, value )
        {
            this.eventManager = value
        },
        
        setUuid( state, value )
        {
            state.uuid = value
            this.database.writeStorage( 'uuid', value )
        },
        
        setOnline( state, value )
        {
            state.online = value
        },
        
        setAuthorized( state, value )
        {
            state.authorized = value
            if ( true === value ) {
                window.authKey = this.getters.uuid
                this.eventManager.dispatch( 'on-auth-trigger' )
            }
            this.database.writeStorage( 'authorized', value )
        },
        
        setLocalSessionId( state, value )
        {
            state.localSessionId = value
            this.database.writeStorage( 'localSessionId', value )
        },
        
        setRemoteSessionId( state, value )
        {
            state.remoteSessionId = value
            this.database.writeStorage( 'remoteSessionId', value )
        },
        
        setIdUser( state, value )
        {
            state.idUser = value
            this.database.writeStorage( 'idUser', value )
        },
        
        setUsername( state, value )
        {
            state.username = value
            this.database.writeStorage( 'username', value )
        },
        
        setEncryptedPrivateKey( state, value )
        {
            state.encryptedPrivateKey = value
            this.database.writeStorage( 'encryptedPrivateKey', value )
        },
        
        setPublicKey( state, value )
        {
            state.publicKey = value
            this.database.writeStorage( 'publicKey', value )
        },
        
        setProxyKey( state, value )
        {
            state.proxyKey = value
            this.database.writeStorage( 'proxyKey', value )
        },
        
        setLastTick( state, value )
        {
            state.lastTick = value
            this.database.writeStorage( 'lastTick', value )
        },
        
        setSerial( state, value )
        {
            state.serial = value
            this.database.writeStorage( 'serial', value )
            this.eventManager.dispatch( 'on-serial-update', value )
        },
        
        setLocalUrl( state, value )
        {
            state.localUrl = value
            this.database.writeStorage( 'localUrl', value )
        },
        
        setRemoteUrl( state, value )
        {
            state.remoteUrl = value
            this.database.writeStorage( 'remoteUrl', value )
        },
        
        setStoreInitialized( state, value )
        {
            state.storeInitialized = value
        },
        
        setLocalConnected( state, value )
        {
            state.localConnected = value
        },
        
        setLocalAuthorized( state, value )
        {
            state.localAuthorized = value
        },
        
        setRemoteConnected( state, value )
        {
            state.remoteConnected = value
        },
        
        setRemoteAuthorized( state, value )
        {
            state.remoteAuthorized = value
        },
        
        initStates()
        {
            
            let promises = []

            for ( const [ key, value ] of Object.entries( this.state ) ) {
                
                if ( 'dbConnected' !== key
                     && 'online' !== key ) {
                    
                    let todo = 'set' + key.charAt( 0 ).toUpperCase() + key.slice( 1 )
                    
                    promises.push( new Promise( resolve =>
                    {
                        
                        this.database.readStorage( key )
                            .then( result =>
                            {
                                this.commit( todo, result )
                                return resolve()
                                
                            } )
                            .catch( () =>
                            {
                                this.commit( todo, value )
                                return resolve()
                            } )
                        
                    } ) )
                    
                }
                
            }
            
            Promise.all( promises )
                   .then( () =>
                   {
                       
                       if ( false !== this.getters.idSession
                            && this.getters.lastTick < ( Date.now() - ( 119 * 60000 ) ) ) {
                           this.commit( 'setLocalSessionId', false )
                           setTimeout( () =>
                           {
                               this.eventManager.dispatch( 'on-session-timeout' )
                           }, 500 )
                       }
                       
                       this.commit( 'setStoreInitialized', true )
                       this.eventManager.dispatchIndexed( 'on-store-initialized' )
                       this.eventManager.dispatch( 'after-store-init-states' )
                       
                   } )
            
        }
        
    },
    
    getters: {
        
        dbConnected:         state => state.dbConnected,
        uuid:                state => state.uuid,
        online:              state => state.online,
        authorized:          state => state.authorized,
        localSessionId:      state => state.localSessionId,
        remoteSessionId:     state => state.remoteSessionId,
        idUser:              state => state.idUser,
        username:            state => state.username,
        serial:              state => state.serial,
        localUrl:            state => state.localUrl,
        remoteUrl:           state => state.remoteUrl,
        encryptedPrivateKey: state => state.encryptedPrivateKey,
        publicKey:           state => state.publicKey,
        proxyKey:            state => state.proxyKey,
        lastTick:            state => state.lastTick,
        storeInitialized:    state => state.storeInitialized,
        localConnected:      state => state.localConnected,
        remoteConnected:     state => state.remoteConnected,
        localAuthorized:     state => state.localAuthorized,
        remoteAuthorized:    state => state.remoteAuthorized
        
    },
    
    actions: {
        
        waitReady()
        {
            return new Promise( ( resolve ) =>
            {
                if ( this.getters.storeInitialized ) {
                    return resolve()
                } else {
                    setTimeout( () =>
                    {
                        return resolve( this.dispatch( 'waitReady' ) )
                    }, 300 )
                }
            } )
        },
        
        destroySession( { commit } )
        {
            return new Promise( ( resolve ) =>
            {
                
                commit( 'setLocalAuthorized', false )
                commit( 'setLocalSessionId', false )
                commit( 'setLastTick', null )
                commit( 'setIdUser', false )
                this.eventManager.dispatch( 'reset-all' )
                
                return resolve()
                
            } )
        },
        
        flushStorage( { commit } )
        {
            
            return new Promise( ( resolve ) =>
            {
                
                commit( 'setLocalAuthorized', false )
                commit( 'setLocalSessionId', false )
                commit( 'setLastTick', null )
                commit( 'setStoreInitialized', false )
                commit( 'setUuid', null )
                commit( 'setOnline', false )
                commit( 'setIdUser', false )
                commit( 'setUsername', false )
                commit( 'setEncryptedPrivateKey', false )
                this.eventManager.dispatch( 'reset-all' )
                
                return resolve()
                
            } )
            
        },
        
        prepareUserChange( { commit } )
        {
            
            return new Promise( ( resolve ) =>
            {
                
                commit( 'setLocalAuthorized', false )
                commit( 'setLocalSessionId', false )
                commit( 'setUuid', null )
                commit( 'setIdUser', false )
                commit( 'setUsername', false )
                commit( 'setEncryptedPrivateKey', false )
                
                return resolve()
                
            } )
            
        }
        
    }
    
} )